import { render, staticRenderFns } from "./Bbs.vue?vue&type=template&id=40b10756&scoped=true"
import script from "./Bbs.vue?vue&type=script&lang=ts"
export * from "./Bbs.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./Bbs.vue?vue&type=style&index=0&id=40b10756&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "40b10756",
  "681df99f"
  
)

export default component.exports